import styled from 'styled-components'

export const PerksContainer = styled.div<{ componentStyle: string }>`
    ${(props) => props.componentStyle}
    border: var(--dashboard-default-border);
    border-radius: var(--dashboard-border-radius);
    display: flex;
    flex-direction: column;
    background-color: var(--dashboard-basic-background-color);
    header {
        background-color: var(--dashboard-badge-color);
        text-align: center;
        padding: 10px;
        border-top-left-radius: var(--dashboard-border-radius);
        border-top-right-radius: var(--dashboard-border-radius);
        font-weight: bold;
        font-size: 1em;
        color: var(--dashboard-black-color);
        height: 40px;
    }

    footer {
        padding: 0 2em 2em 2em;
        p {
            text-align: center;
            font-weight: 400;
        }
        button {
            border: none;
            border-radius: 2px;
            font-size: 15px;
            color: var(--dashboard-white-color);
            background-color: var(--dashboard-main-color);
            padding: 8px 25px;
            width: 100%;
            animation: fadeIn 0.6s ease-in-out;
        }
    }
    &:hover {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
    animation: fadeIn 0.4s ease-in-out;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(0, -20px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
`
export const BadgeList = styled.div`
    flex-grow: 1;
    h4 {
        color: var(--dashboard-main-color);
        text-align: center;
        padding: 15px 0;
        letter-spacing: 0.05em;
    }
    figure {
        text-align: center;
        svg {
            width: 100%;
            height: 100px;
            margin: 1em auto;
        }
    }
    ul {
        padding-right: 10px;
        padding-left: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        li {
            margin-bottom: var(--dashboard-default-gap);
            list-style: none;
            font-size: 16px;
            svg {
                position: absolute;
                transform: translate(-35px, 5px);
                color: var(--dashboard-main-color);
                width: 22px;
                height: 22px;
            }
        }
    }
`
